<template>
  <div>
    <div style="background-color: #fff; padding: 16px; margin-bottom: 20px">
      <a-form-model
        size="small"
        layout="inline"
        :model="ajaxparams"
        @keyup.native.enter="onSearchClick"
      >
        <a-form-model-item label="商品编号">
          <a-input
            placeholder="请输入商品编号"
            v-model="ajaxparams.goods_number_like"
          />
        </a-form-model-item>
        <a-form-model-item label="商品名称">
          <a-input
            placeholder="请输入商品名称"
            v-model="ajaxparams.goods_name_like"
          />
        </a-form-model-item>
        <a-form-model-item label="员工名称">
          <a-input
            placeholder="请输入员工名称"
            v-model="ajaxparams.employee_name_like"
          />
        </a-form-model-item>
        <a-form-model-item label="检测时间">
          <a-range-picker
            v-model="dateRange"
            @change="onDateChange"
            :placeholder="['开始日期', '结束日期']"
            format="YYYY-MM-DD"
          />
        </a-form-model-item>
        <a-form-model-item>
          <a-button icon="search" @click="onSearchClick" type="primary"
            >搜索</a-button
          >
          <a-button @click="reset()" style="margin-left: 8px">重置</a-button>
        </a-form-model-item>
      </a-form-model>

      <MyTable
        class="mt10"
        :apiUrl="packingGoods_statistics"
        :params="ajaxparams"
        ref="myTable"
        :columns="columns"
        :isSelection="false"
      >
      </MyTable>
    </div>
  </div>
</template>

<script>
import MyTable from "@/components/myTable.vue";
import { packingGoods_statistics } from "@/api/quality";

export default {
  name: "QualityStatistics",
  components: { MyTable },
  data() {
    return {
      packingGoods_statistics: packingGoods_statistics,
      ajaxparams: {},
      dateRange: [],
      columnsAll: [
        {
          title: "商品编号",
          dataIndex: "goods_number",
          key: "goods_number",
          width: 140,
        },
        {
          title: "商品名称",
          dataIndex: "goods_name",
          key: "goods_name",
          width: 240,
          ellipsis: true,
        },
        {
          title: "员工名称",
          dataIndex: "employee_name",
          key: "employee_name",
          width: 160,
        },
        { title: "规格", dataIndex: "spec_type", key: "spec_type", width: 120 },
        {
          title: "总数量/小时数",
          dataIndex: "total_num",
          key: "total_num",
          width: 100,
        },
      ],
      showEmployeeColumn: false,
    };
  },
  computed: {
    columns() {
      return this.showEmployeeColumn
        ? this.columnsAll
        : this.columnsAll.filter((c) => c.key !== "employee_name");
    },
  },
  methods: {
    reset() {
      this.ajaxparams = {};
      this.dateRange = [];
      this.showEmployeeColumn = false;
      this.$refs.myTable.search();
    },
    onSearchClick() {
      const val =
        this.ajaxparams &&
        typeof this.ajaxparams.employee_name_like === "string"
          ? this.ajaxparams.employee_name_like.trim()
          : "";
      this.showEmployeeColumn = !!val;
      this.$refs.myTable.search();
    },
    onDateChange(dates, dateStrings) {
      if (dates && dates.length === 2) {
        this.ajaxparams.create_date_between = `${dateStrings[0]} - ${dateStrings[1]}`;
      } else {
        delete this.ajaxparams.create_date_between;
      }
    },
  },
};
</script>

<style scoped></style>
